import { combineReducers, createStore, applyMiddleware, Store, Action } from 'redux';
import thunkMiddleware, { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AuthState } from './auth/types';
import { authReducer } from './auth/reducer';
import { NotificationState } from './notification/types';
import { notificationReducer } from './notification/reducer';
import { PersonProfileState } from './personProfile/types';
import { personProfileReducer } from './personProfile/reducer';
import { GlobalLoaderState } from './globalLoader/types';
import { globalLoaderReducer } from './globalLoader/reducer';

export interface ApplicationState {
  auth: AuthState;
  notification: NotificationState;
  personProfile: PersonProfileState;
  loader: GlobalLoaderState;
}

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  ApplicationState,
  null,
  Action<string>
>;
export type AppThunkDispatch = ThunkDispatch<ApplicationState, null, Action>;

export const rootReducer = combineReducers<ApplicationState>({
  auth: authReducer,
  notification: notificationReducer,
  personProfile: personProfileReducer,
  loader: globalLoaderReducer,
});

function configureStore(initialState?: ApplicationState): Store<ApplicationState> {
  const store = createStore(rootReducer, initialState, applyMiddleware(thunkMiddleware));
  return store;
}

export default configureStore();
